/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_App_Feature_PlansInputs */

const en_price_page_app_feature_plans = /** @type {(inputs: Price_Page_App_Feature_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your own plans, adapting after every workout`)
};

const pl_price_page_app_feature_plans = /** @type {(inputs: Price_Page_App_Feature_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Własne plany, które dopasowują się po każdym treningu`)
};

/**
* | output |
* | --- |
* | "Your own plans, adapting after every workout" |
*
* @param {Price_Page_App_Feature_PlansInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_app_feature_plans = /** @type {((inputs?: Price_Page_App_Feature_PlansInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_App_Feature_PlansInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_app_feature_plans(inputs)
	return en_price_page_app_feature_plans(inputs)
});